
import Vue from 'vue';

export default Vue.extend({
  name: 'WelcomePhone',
  created() {
    if (process.env.VUE_APP_MODE === 'PROD') {
      (this as any).$gtm.trackView( location.pathname.toString() , location.toString());
      // window.location.replace('/service/top');
    } else {
      window.location.replace('/Login');
    }
  },
});
